import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Tone = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1 9H4.069a7.965 7.965 0 01.52-2H11v2zm0 4H4.589a7.965 7.965 0 01-.52-2H11v2zm0-10.931V7H5.765A7.996 7.996 0 0111 4.069zM5.765 17H11v2.931A7.996 7.996 0 015.765 17zM13 19.931V4.069c3.939.495 7 3.858 7 7.931s-3.061 7.436-7 7.931z",
    key: "k0"
  }));
});
Tone.displayName = 'Tone';
export var ToneDimensions = {
  height: 24,
  width: 24
};